import ApplyStepIcon from 'components/ApplyStepIcon'

import s from './ApplyComplete.module.css'
import isModellinkSite from '../../helpers/isModellinkSite'
import { useAtom } from 'jotai/index'
import { sitesAtom } from '../../lib/atoms'

//TODO: setup proptypes
function ApplyComplete({ siteSlug, title = 'Thank you for applying' }) {
  const [sites] = useAtom(sitesAtom)
  const site = sites.find((s) => s.path === `/${siteSlug}/`)
  const instagramUrl = isModellinkSite() ? 'https://www.instagram.com/modellinkagency/' : 'https://www.instagram.com/selectmodelglobal/'
  return (
    <div className={s.container}>
      <h1 className={s.title}>{title}</h1>
      <p className={s.text}>If you {`haven't`} already you should follow us.</p>
      {site && site.followMenu ? (
        site.followMenu.map((l) => (
          <a className={s.button} target='_blank' key={l.link} href={l.link}>
            {l.label}
          </a>
        ))
      ) : (
        <a
          className={s.button}
          target='_blank'
          href={instagramUrl}
          rel={'nofollow'}
        >
          Follow us
        </a>
      )}
      <ApplyStepIcon step='tick' />
    </div>
  )
}

export default ApplyComplete
